import { AccountGetResponse, MLSID, isUndefined } from '@aloft/toolkit-shared';

import { RootState } from '../types.ts';
import { migrateFTUXFromLocalStorage } from './migrateFTUXFromLocalStorage.ts';

export function accountReqToState(accountReq: AccountGetResponse): RootState['account'] {
  const { id, email, body, userType, isAdmin } = accountReq;
  const {
    firstName,
    lastName,
    phone,
    mlsIDs,
    isOnboardingComplete,
    ftux,
    mcKissockData,
    signatureBlobId,
  } = body;

  return {
    id,
    email,
    firstName,
    lastName,
    phone,
    mlsIDs: (mlsIDs ?? []) as MLSID[],
    isOnboardingComplete: isUndefined(isOnboardingComplete) ? true : isOnboardingComplete,
    ftux: ftux ?? migrateFTUXFromLocalStorage(),
    mcKissockData,
    signatureBlobId,
    userType,
    isAdmin,
  };
}
